import api from "../index";
import { qs } from "../../utils/utils"
 
export const GetAllDashboardApi = () => api.get('admin/admin-dashboard');
export const GetDashboardDepositWithdrawApi = (params) => api.get(`admin/admin-dashboard-deposit-withdraw?${qs(params)}`);
export const GetAllDashboardPLApi = () => api.get('trading/admin-dashboard-user-count');
